import React, { Component } from 'react'
import { connect } from 'react-redux';

const mapStateToProps = (state, ownProps) => {
    const projects = state.distributionTree.distsByType["projects"] || {};
	return {
		//config: state.ui.config
        projects: projects
	}
}

const mapDispatchToProps = (dispatch) => {
	return {}
}

const projectPath = (props) => {
        if(!props.id || !props.projects.tagTreeList) return "";
        
        const from = props.id;
        let path = [];
        
        if(props.projects.tagTreeList[from]) {
            path = props.projects.tagTreeList[from].parentIds.map(id => {
                return props.projects.tagTreeList[id].name;
            });
        }
        
        path.push(props.projects.tagTreeList[from].name);
        path.length && path.shift();

        return path.join(' / ');
	}
	
export const ProjectPath = connect(mapStateToProps, mapDispatchToProps)(projectPath);
